import {
  SET_HEADER_TITLE,
} from '../types';

const defaultState = {
  headerTitle: '...',
};

const header = (state = defaultState, action) => {
  switch (action.type) {
    case SET_HEADER_TITLE:
      return Object.assign({}, defaultState, {
        headerTitle: action.payload.title,
      });

    default:
      return state;
  }
};

export default header;



// WEBPACK FOOTER //
// ./src/state/reducers/header.js